<script setup>
import RadioListField from '@maison/components/form/fields/RadioListField.vue';
import FormGroup from '@maison/components/form/FormGroup.vue';
import { defineModel, ref } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  products: {
    type: Array,
    required: true,
  },
});

const value = defineModel({ type: String });

const field = ref({
  id: props.id,
  name: 'product',
  required: false,
  options: props.products,
});
</script>

<template>
  <div class="radio-group-products-wrapper">
    <form-group :attrs="field" class="radio-group--products" is-fieldset :has-fieldset-fields-wrapper="false">
      <radio-list-field v-model="value" type="product" />
    </form-group>
  </div>
</template>
